import * as React from "react";
import Container from "../../common/Container";
import { color } from "../../../styles/color";
import { Dropdown, TablePaginationConfig, Table } from "antdv5";
import {
  DownOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
} from "@ant-design/icons";
import type {
  MonkeyPatchedIMessage,
  SetState,
  Fn,
} from "../../../client_types";
import type { MenuProps } from "antdv5";

interface ISearchValue {
  feetNo: string;
  matchNumber: string;
  memberName: string;
}
interface IPageInfo {
  pageSize: number | undefined | null;
  current: number | undefined | null;
}
interface IData {
  data: MonkeyPatchedIMessage[];
  count: number | null;
}
type PreventRefreshCount<T> = (fn: T, count: number) => void;
type SearchData = (pageSize: number, current: number) => void;

interface IProps {
  storageSearchValue: ISearchValue;
  data: IData;
  pageInfo: IPageInfo;
  sortText: "正序" | "倒序";
  loading: boolean;
  setStorageSearchValue: SetState<ISearchValue>;
  setPageInfo: SetState<IPageInfo>;
  setLockInput: any;
  setLock: SetState<boolean>;
  preventRefreshCount: PreventRefreshCount<SearchData>;
  searchData: Fn;
  searchNewData: SearchData;
  handleAuth: Fn;
  fetchNewData: (pageSize: number, current: number) => void;
  fakePreventRefresh: () => false;
  handleCurrentPage: () => number | undefined;
  onTableChange: (pagination: TablePaginationConfig) => void;
  handleDownload: () => Promise<void>;
  handleMenuClick: (e: any) => void;
}

const DailyRecordtable = ({
  setStorageSearchValue,
  setPageInfo,
  setLockInput,
  setLock,
  preventRefreshCount,
  searchNewData,
  handleAuth,
  storageSearchValue,
  data,
  pageInfo,
  fetchNewData,
  fakePreventRefresh,
  handleCurrentPage,
  onTableChange,
  loading,
  handleDownload,
  handleMenuClick,
  sortText,
}: IProps) => {
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: "排名(正序)",
      icon: <CaretDownOutlined />,
    },
    {
      key: "2",
      label: "排名(倒序)",
      icon: <CaretUpOutlined />,
    },
  ];
  const onClick: MenuProps["onClick"] = handleMenuClick;
  const columns = [
    {
      title: "序号",
      dataIndex: "rank",
      width: 100,
    },
    {
      title: "参赛编号",
      dataIndex: "House",
      width: 100,
      textWrap: "word-break",
      ellipsis: true,
      render: (text: string) => (
        <div
          style={{ color: "#3d6bff", cursor: "pointer" }}
          onClick={() => {
            setStorageSearchValue({
              ...storageSearchValue,
              matchNumber: text.trim(),
            });
            setPageInfo({ pageSize: 100, current: 1 });
            preventRefreshCount(searchNewData, 3);
            handleAuth();
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "参赛名称",
      dataIndex: "Name",
      width: 180,
      render: (text: string) => (
        <div
          style={{ color: "#3d6bff", cursor: "pointer" }}
          onClick={() => {
            setStorageSearchValue({ ...storageSearchValue, memberName: text });
            setPageInfo({ pageSize: 100, current: 1 });
            preventRefreshCount(searchNewData, 3);
            handleAuth();
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "环号",
      dataIndex: "Ring",
      width: 150,
    },
    {
      title: "日期",
      dataIndex: "Ymd",
      width: 150,
    },
    {
      title: "归巢时间",
      dataIndex: "stringDate",
      width: 150,
    },
    // reserved for possible use in the future
    // {
    //   title: "备注",
    //   dataIndex: "note",
    //   width: 100,
    // },
  ];
  return (
    <Container>
      <Table
        className="bordered-table"
        columns={columns}
        dataSource={data.data}
        pagination={
          data.data.length === 0
            ? {
                defaultPageSize: 100,
              }
            : {
                pageSizeOptions: ["20", "50", "100"],
                locale: { items_per_page: "笔/页" },
                defaultPageSize: data.data.length,
                total: data.count || 100,
                showTotal: () => (
                  <>
                    <Dropdown menu={{ items, onClick }} trigger={["click"]}>
                      <button>
                        {sortText} <DownOutlined />
                      </button>
                    </Dropdown>
                    {localStorage.getItem("onAuth") === "true" ? (
                      <button
                        onClick={handleDownload}
                        disabled={data.data.length === 0}
                      >
                        下载
                      </button>
                    ) : null}
                    <button
                      onClick={() => {
                        fetchNewData(
                          pageInfo.pageSize || 10,
                          pageInfo.current || 1
                        );
                        preventRefreshCount(fakePreventRefresh, 3);
                        setLockInput(true);
                        setLock(true);
                      }}
                    >
                      刷新
                    </button>
                    <div style={{ color: `${color.primaryBlue}` }}>
                      共 {data.data.length > 0 ? data.data[0].ClubCount : "0"}{" "}
                      舍 {data.count ? data.count : "0"} 鸽
                    </div>
                  </>
                ),
                showQuickJumper: true,
                current: handleCurrentPage(),
                position: ["topRight", "bottomRight"],
                responsive: true,
              }
        }
        onChange={onTableChange}
        scroll={{ x: "max-content" }}
        rowKey="id"
        loading={loading}
        sticky
        size="small"
        bordered
      />
    </Container>
  );
};

export default DailyRecordtable;
